export default __webpack_public_path__ + "static/media/placementCell.6cad8fd5.png";